import { useT } from '../../../i18n';
import type { AiTokenDurationUnit } from '../types';

/** Nhãn thời hạn "3 tháng", "1 tuần"; tiếng Anh cần số ít riêng cho 1 ("1 month", không "1 months"). */
export function useNhanThoiHan() {
  const { t } = useT();
  return (donVi: AiTokenDurationUnit, so: number): string =>
    donVi === 'WEEK'
      ? so === 1
        ? t('tokenAi.thMotTuan')
        : t('tokenAi.thTuan', { so })
      : so === 1
        ? t('tokenAi.thMotThang')
        : t('tokenAi.thThang', { so });
}
